//#region src/shared/datarecords.ts
function defineDataRecord(datarecord) {
	return datarecord;
}

//#endregion
export { defineDataRecord };
//# sourceMappingURL=datarecords.js.map